import { render, staticRenderFns } from "./chart-sphere-tones-bar@.vue?vue&type=template&id=dcf9af14&"
import script from "./chart-sphere-tones-bar@.vue?vue&type=script&lang=ts&"
export * from "./chart-sphere-tones-bar@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports